<template>
  <div class="register">
    <!-- <Row :gutter="10" class="top">
      <Col span="8">
        <div class="title">展商报名</div>
      </Col>
    </Row> -->
    <div class="title top">展商报名 Booth Application</div>
    <registerForm ref="registerForm"></registerForm>
    <registerEntrance ref="registerEntrance"></registerEntrance>

    <div class="f-tac submit-btn">
      <Button
        type="primary"
        size="large"
        @click="handleSubmit"
        :loading="loading"
        >确认以上信息，并提交展位申请 Confirm and Submit</Button
      >
    </div>

    <!-- <div class="tip-info">
      <p>注：</p>
      <p>1. 展会主办单位有修改、调整展位图的权利。</p>
      <p>2. 此表仅为展位预定时使用，非正式参展合同。正式参展以展位合同为准。</p>
    </div> -->
  </div>
</template> 

<script>
import { mapActions } from "vuex";
import registerForm from "./components/mobile-register-form.vue";
import registerEntrance from "./components/mobile-register-entrance.vue";
export default {
  name: "register",
  components: {
    registerForm,
    registerEntrance,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: "registerdModule/getApplyCompanyRoastCreate", // 新增展会接口
    }),
    async handleSubmit() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerEntrance.validHandle();
      if (!res2.valid) return;
      console.log("registerForm", res);
      console.log("registerEntrance", res2);
      let opt = {
        newCompany: { ...res.form, ...res2.comon },
        lists: [
          {
            ...res2.ApplyCompanyOrderNewDto,
            // ...res2.ApplyCompanyOrder2
          },
        ],
        reportType: "cn",
      };
      let exname = "";
      res2.exhibition.forEach((c, index) => {
        exname += c.name;
        if (res2.exhibition.length !== index + 1) {
          exname += ",";
        }
      });
      console.log("option", opt);
      let bool = await this.getApplyCompanyRoastCreate(opt);
      console.log("getApplyCompanyRoastCreate", bool);
      if (bool && bool.successed) {
        let query =
          "company=" +
          encodeURI(res.form.companyName) +
          "&exname=" +
          encodeURI(exname);
        this.$router.push(`/ex-register/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "提交失败，请重新尝试！";
        if (bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
  },
  created() {
    if (this.IsPC()) {
      this.$router.push(`/ex-register/register`);
    }
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.register {
  max-width: 1200px;
  margin: 0 auto;
  .top {
    padding: 15px;
  }
  .title {
    font-size: 15px;
    color: #4f65ae;
    font-weight: bold;
    line-height: 32px;
  }
}
.submit-btn {
  margin-top: 50px;
  text-align: center;
  button {
    padding: 0 24px;
    background-image: linear-gradient(-90deg, #18c1cd 0%, #6449ba 100%),
      linear-gradient(#b10042, #b10042);
    font-size: 16px;
    margin-bottom: 30px;
    height: 40px;
    border-radius: 20px;
    font-size: 15px;
    color: #fff;
    border: none;
  }
}
.tip-info {
  margin: 0 auto 48px;
  padding: 15px;
  white-space: nowrap;
  p {
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
    white-space: normal;
  }
}
</style>
